module.exports = __webpack_public_path__ + "images/file_icons_v2/pages-76216b45d5edf1d9c91298d7cc9a3f00.svg";